import SectionLabel from "@/components/base/SectionLabel";
import { businessToolData } from "@/mocks/businessToolData";

export default function DevelopmentExamplesSection() {
  const scrollToContact = () => {
    const el = document.querySelector("#contact");
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section id="development-examples" className="py-20 md:py-28 bg-background-100">
      <div className="max-w-[1200px] mx-auto px-4 md:px-8">
        <div className="text-center mb-10 md:mb-14 reveal">
          <SectionLabel
            label={businessToolData.developmentExamples.label}
            className="mb-3"
          />
          <h2 className="font-heading text-2xl md:text-3xl lg:text-4xl font-bold text-foreground-900">
            {businessToolData.developmentExamples.title}
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5 max-w-5xl mx-auto">
          {businessToolData.developmentExamples.categories.map((cat, idx) => (
            <div
              key={cat.num}
              className="reveal flex flex-col rounded-lg bg-background-50 border border-background-200/70 p-5 md:p-6 hover:border-primary-200/60 transition-all duration-300"
              style={{ transitionDelay: `${idx * 80}ms` }}
            >
              <div className="flex items-center gap-2 mb-3">
                <span className="text-xs font-bold text-primary-500 font-label">
                  {cat.num}
                </span>
                <div className="w-6 h-6 rounded-md bg-primary-500/10 flex items-center justify-center">
                  <i className={`${cat.icon} text-primary-500 text-sm`} />
                </div>
                <h3 className="text-sm font-bold text-foreground-900 font-heading">
                  {cat.title}
                </h3>
              </div>

              <ul className="space-y-1.5 flex-1">
                {cat.items.map((item, i) => (
                  <li key={i} className="flex items-start gap-1.5 text-xs text-foreground-600">
                    <i className="ri-check-line text-primary-500 mt-0.5 flex-shrink-0" />
                    {item}
                  </li>
                ))}
              </ul>

              {cat.note && (
                <div className="mt-3 pt-3 border-t border-background-200/60">
                  <p className="text-[11px] text-foreground-500 leading-relaxed">
                    <i className="ri-information-line text-secondary-500 mr-1" />
                    {cat.note}
                  </p>
                </div>
              )}
            </div>
          ))}
        </div>

        <div className="mt-10 md:mt-12 reveal">
          <div className="max-w-2xl mx-auto text-center bg-background-50 border border-primary-200/60 rounded-lg p-7 md:p-9">
            <h3 className="text-base md:text-lg font-bold text-foreground-900 mb-4 font-heading">
              それ以外の内容も、業務内容を確認してご提案します。
            </h3>
            <p className="text-sm text-foreground-600 mb-5 leading-relaxed">
              ここに記載されていない業務でも、ご相談いただければ対応可能かを検討します。
            </p>
            <button
              onClick={scrollToContact}
              className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-md bg-primary-500 text-background-50 text-sm md:text-base font-medium hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
            >
              業務ツールについて相談する
              <i className="ri-arrow-right-line" />
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}